import AppContext from "PFApp/app_context";
import PageBox from "PFComponents/box/page_box";
import { Button } from "PFComponents/button";
import Checkbox from "PFComponents/checkbox/checkbox";
import DataTable from "PFComponents/data_table/data_table";
import NoBackdropDropdownButton from "PFComponents/dropdown/no_backdrop_dropdown_button";
import SimplePagination from "PFComponents/pagination/simple_pagination";
import { ApiRoute } from "PFCore/utilities/routes";
import DownArrowIcon from "PFIcons/down_arrow.svg";
import { GROWL_ACTIONS } from "PFReducers/growl_reducer";
import Proptypes from "prop-types";
import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";

import css from "./send_welcome_email_page.less";

const checkboxRenderer = (data, selected, setSelected) => {
  const isChecked = selected.filter((item) => item === data.id)?.length > 0;
  return (
    <Checkbox
      checked={isChecked}
      handleChange={() => {
        isChecked
          ? setSelected(selected.filter((item) => item !== data.id))
          : setSelected([data.id, ...selected]);
      }}
    />
  );
};

const SendWelcomeEmailPage = ({ users, fetchUsers }) => {
  const { t } = useTranslation("admin", { keyPrefix: "user" });
  const { dispatch } = useContext(AppContext);
  const { entries, meta } = users;
  const [selected, setSelected] = useState([]);

  const options = [
    {
      id: "select-all",
      displayElement: "Select All",
      item: "select-all"
    },
    {
      id: "clear-selection",
      displayElement: "Clear Selection",
      item: "clear-selection"
    }
  ];

  const DropDown = () => (
    <NoBackdropDropdownButton
      dropDownStyle={{ width: 150, left: 0 }}
      buttonKind="secondary"
      options={options}
      handleChange={(item) => setSelected(item === "select-all" ? entries.map((item) => item.id) : [])}
    >
      <DownArrowIcon height={20} width={20} />
    </NoBackdropDropdownButton>
  );

  const sendEmails = () => {
    if (
      confirm(
        t("sendWelcomeEmails.areYouSure", {
          count: selected.length
        })
      )
    ) {
      $.ajax({
        url: ApiRoute("/api/admin/users/send_welcome_emails"),
        method: "POST",
        data: {
          profile_ids: selected
        }
      })
        .then(() => {
          dispatch({
            type: GROWL_ACTIONS.GROWL_RENDER,
            payload: {
              message: t("sendWelcomeEmails.successMessage"),
              kind: "success"
            }
          });
          setSelected([]);
          fetchUsers(meta?.page);
        })
        .catch(() => {
          dispatch({
            type: GROWL_ACTIONS.GROWL_RENDER,
            payload: {
              message: t("sendWelcomeEmails.errorMessage"),
              kind: "error"
            }
          });
        });
    }
  };

  return (
    <div className={css.wrapper}>
      <div className={css.header}>
        <h1>{t("sendWelcomeEmails.title")}</h1>
        <Button
          text={t("sendWelcomeEmails.toSelectedUsers")}
          onClick={sendEmails}
          disabled={selected.length === 0}
        />
      </div>
      <PageBox>
        {meta.total > 0 ? (
          <DataTable
            columns={[
              {
                headerName: <DropDown />,
                renderCell: (data) => checkboxRenderer(data, selected, setSelected),
                narrow: true
              },
              {
                headerName: t("name"),
                cellKey: "name"
              },
              {
                headerName: t("email"),
                cellKey: "email"
              },
              {
                headerName: t("sendWelcomeEmails.createdAt"),
                cellKey: "created_at"
              }
            ]}
            data={entries}
          />
        ) : (
          <div className={css.notFound}>Access request not found</div>
        )}
      </PageBox>
      <div className={css.pagination}>
        <SimplePagination currentPage={meta?.page} totalPages={meta?.totalPages} handleClick={fetchUsers} />
      </div>
    </div>
  );
};

SendWelcomeEmailPage.propTypes = {
  users: Proptypes.shape({
    meta: Proptypes.array,
    entries: Proptypes.array
  }),
  fetchUsers: Proptypes.func
};
export default SendWelcomeEmailPage;
